import Vue from "vue";
import Vuex from "vuex";
import { getElementMarkdown } from "../utils/helpers";
import { POSITION } from "vue-toastification";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    elements: [],
    selected: null,
    theme: "github",
  },
  mutations: {
    addNewElement(state, element) {
      state.elements.push(element);
    },
    addNewElementAtIndex(state, data) {
      const { addedIndex, elementToAdd } = data;
      state.elements.splice(addedIndex, 0, elementToAdd);
      state.selected = null;
    },
    setElements(state, data) {
      state.elements = data;
    },
    setSelected(state, data) {
      state.selected = data;
    },
    setValueOfSelectedElement(state, data) {
      state.elements[state.selected].value = data;
    },
    addNewListItem(state, index) {
      state.elements[state.selected].value.splice(index, 0, {
        prefix: "-",
        indent: 0,
        value: "test",
      });
    },
    removeListItem(state, index) {
      let removedItem = state.elements[state.selected].value.splice(
        index,
        1
      )[0];
      console.log(removedItem);
    },
    setValueOfListItem(state, data) {
      state.elements[state.selected].value[data.index].value = data.value;
    },
    toggleTheme(state) {
      if (state.theme == "standard") state.theme = "github";
      else state.theme = "standard";
    },
    clearElements(state) {
      state.elements = [];
    },
  },
  getters: {
    elements: (state) => {
      return state.elements;
    },
    theme: (state) => {
      return state.theme;
    },
    selectedElement: (state) => {
      return state.elements[state.selected];
    },
    selectedElementIndex: (state) => {
      return state.selected;
    },
    code: (state) => {
      let string = "";
      state.elements.forEach((element) => {
        string += getElementMarkdown(element, true);
        string += "\n";
        string += "\n";
      });
      return string;
    },
  },
  actions: {
    onDropElement({ commit, state }, dropResult) {
      const { removedIndex, addedIndex, payload } = dropResult;
      //console.log(dropResult);
      if (removedIndex === null && addedIndex === null) return state.elements;

      let elementToAdd = payload;

      if (removedIndex !== null) {
        elementToAdd = state.elements.splice(removedIndex, 1)[0];
      }

      if (addedIndex !== null) {
        commit("addNewElementAtIndex", {
          addedIndex,
          elementToAdd,
        });
      }
    },
    setSelectedElement({ commit }, index) {
      commit("setSelected", index);
    },
    setElementValueById({ commit }, value) {
      commit("setValueOfSelectedElement", value);
    },
    addNewListItem({ commit }, index) {
      commit("addNewListItem", index);
    },
    removeListItem({ commit }, index) {
      commit("removeListItem", index);
    },
    setValueOfListItem({ commit }, data) {
      commit("setValueOfListItem", data);
    },
    toggleTheme({ commit }) {
      commit("toggleTheme");
    },
    clearAll({ commit }) {
      commit("clearElements");
    },
    removeElement({ state }, id) {
      state.elements.splice(id, 1)[0];
      this._vm.$toast.success("Successfully deleted element!", {
        position: POSITION.BOTTOM_CENTER,
      });
    },
  },
  modules: {},
});
